import React, {Component} from 'react';
import DropzoneComponent from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css'
import 'dropzone/dist/min/dropzone.min.css'
import {client} from '../../Client';
import ErrorMessageTiny from '../ErrorMessageTiny'
import PropTypes from 'prop-types';
class DocumentiUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _loading: false,
            error: null
        };
    }

    componentWillMount() {
        this.componentConfig = {
            iconFiletypes: ['.jpeg', '.jpg'],
            showFiletypeIcon: true,
            postUrl: client.getPostUrl('/api/uploadprofilo/'+client.getCurrentUserId()),
        };
        this.djsConfig = {
            method: 'post',
            autoProcessQueue: true,
            addRemoveLinks: false,
            acceptedFiles: ".jpeg,.jpg",
            uploadMultiple: false,
            maxFiles: 1,
            dictDefaultMessage: "Trascina qui un'immagine da associare al proprio profilo.<br/>Formato: <b>file jpeg quadrato di buona qualità (ad es. 500x500)</b>",
            paramName: "imgFile",
            params: {
               
            }
        };
        this.eventHandlers = {
            init: (dropzone) => {
                this.dropzone = dropzone;
            },
            success: (fileData, data) => {
                this.setState({
                    _loading: false,
                    error: null
                });
                if (this.props.onUpload !== undefined)
                {
                    this.props.onUpload(data);
                }
                if (this.dropzone)
                {
                    this.dropzone.removeAllFiles(true);
                }
            },
            error: (file, errorMsg, obj) => {
                let errObj = JSON.parse(errorMsg);
                let msg = errorMsg;
                if (errObj !== undefined && errObj.msg !== undefined)
                {
                    msg = errObj.msg ;
                }
                this.setState({
                    _loading: false,
                    error: {title: "Errore imprevisto", msg: "Impossibile effettuare l'upload del file: " + msg},
                });
                if (this.dropzone)
                {
                    this.dropzone.removeAllFiles(true);
                }
            }
        };

    }

    render() {
        return (
            <div><div className="ui form">
            <div className="fields">
                <div className="sixteen wide field">

                    <DropzoneComponent config={this.componentConfig}
                                       eventHandlers={this.eventHandlers}
                                       djsConfig={this.djsConfig} />
                    </div>
                </div>

            </div>
                <ErrorMessageTiny error={this.state.error} />
            </div>)
    }
}

DocumentiUpload.PropTypes = {
    onUpload: PropTypes.func
}

export default DocumentiUpload;




/** WEBPACK FOOTER **
 ** ./src/components/utenti/ImgProfiloUpload.js
 **/